import { AlertCircle } from 'lucide-react';
import { Callout } from '@radix-ui/themes';

export interface ServerErrorCalloutProps {
  message: string;
}

/** API / async form error — Themes Callout alert with destructive text (not the orange hint Callout). */
export function ServerErrorCallout({ message }: ServerErrorCalloutProps) {
  return (
    <Callout.Root
      color="crimson"
      role="alert"
      variant="surface"
      size="1"
      style={{ alignItems: 'center' }}
    >
      <Callout.Icon>
        <AlertCircle size={16} />
      </Callout.Icon>
      <Callout.Text size="1" style={{ margin: 0 }}>
        {message}
      </Callout.Text>
    </Callout.Root>
  );
}
